import { ConfigData } from 'src/modules/config/types/ConfigData';
import { ConfigI18n } from 'src/modules/config/types/ConfigI18n';
import { Language } from 'src/types/common/Language';
import { createActions } from 'src/utils/createActions';

export const CONFIG_FETCH = createActions<void, ConfigData>('CONFIG_FETCH');
export const CONFIG_LANGUAGE_SWITCH = createActions<Language, ConfigI18n>('CONFIG_LANGUAGE_SWITCH');
